module.exports = __webpack_public_path__ + "img/doer.f82ee355.png";